import { memo } from "react";
import { Link } from 'react-router-dom';    
interface prop {
    nav: any;
    button_text: string;
    onClickItem: any;
    from?:String
}

function ThumbItem(props: prop) {
    let { onClickItem, nav, button_text } = props
    return (
        <Link
            to={{pathname:nav,state:props.from}}
            className="slider-item"
            // onClick={() => {
            //     onClickItem()
            // }}
            >
            <div style={{ marginLeft: 10, marginRight: 10 }}>
                <div style={{
                       border: '1px solid #ccc',
                       display: 'flex',
                       alignItems: 'center',
                       justifyContent: 'center',
                       backgroundColor: '#fff',
                       position: 'relative'
                }}><img src={'images/transparent.png'}/>
                <div style={{
                        position: 'absolute',
                        top: 0,
                        left: 0,
                        width: '100%',
                        height: '100%',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        fontSize: '16px',
                        fontWeight: 600,
                        padding: '15px',
                        textAlign: 'center',
                        color: "#333"
                }}>{button_text}</div>
                </div>
            </div>
        </Link>
    );
}
export default memo(ThumbItem);